import React from 'react';
import { Notification, Button } from 'wix-style-react';
import { Text } from '../PageElements/Text';
import style from './PreviewNotification.scss';
import { CustomLink } from '../PageElements/CustomLink';
import { useLocation } from 'react-router';
import {
  isBranch,
  MENU_EDITOR_PATH,
  parseQueryString,
} from '../../../utils/locationUtils';

export const PreviewNotification = () => {
  const location = useLocation();
  const getBranchName = () => {
    const queryObject = parseQueryString(location.search);
    return ` "${queryObject.branch}" `;
  };

  const getBranchIncludeMenuEditorText = () => (
    <React.Fragment>
      This is a draft of the
      <Text light weight="normal" tagName="span">
        {getBranchName()}
      </Text>
      branch, including Menu Editor changes.
    </React.Fragment>
  );

  return (
    <Notification theme="standard" show type="sticky" zIndex={999999999999}>
      <Notification.TextLabel>
        <Text light weight="thin" dataHook="preview-notification-label">
          {isBranch(location)
            ? getBranchIncludeMenuEditorText()
            : 'This is a draft of the Menu Editor changes.'}
          <CustomLink
            to={{ pathname: MENU_EDITOR_PATH }}
            data-hook="back-to-menu-editor"
            className={style.backToMenuEditor}
          >
            <Button size="small" skin="transparent">
              Back To Menu Editor
            </Button>
          </CustomLink>
        </Text>
      </Notification.TextLabel>
    </Notification>
  );
};
